export default {
    logCorrectCharacter({ commit }, character) {
        commit('incrementNumberOfChars');
        if (character && !character.match(/[a-z]/i)) {
            commit('incrementNumberOfNonLetters');
        }
    },
    logAnError({ commit }, { letterPressed, correctLetter, errCategory = 'Char' }) {
        const errorEntry = {};
        errorEntry.errCategory =
            letterPressed === 'key' ? 'DNDplace' : errCategory;
        errorEntry.right = correctLetter;
        errorEntry.wrong =
            letterPressed.charCodeAt(0) < 32 || letterPressed.charCodeAt(0) > 126
                ? 'cntl'
                : letterPressed;
        commit('addToErrorArray', errorEntry);
    }
};
